<template>
  <a class="button" :href="pinMapAppUrl">
    <span>
      <icon-pin>Drop Pin</icon-pin>
    </span>
  </a>
</template>

<script>
import IconPin from "@/components/icons/IconPin";

export default {
  components: {
    IconPin
  },
  props: {
    location: Object
  },
  computed: {
    pinMapAppUrl: function() {
      // TODO: Google Maps link for Android
      return (
        "https://maps.apple.com/?q=" +
        encodeURIComponent(this.location.label) +
        "&ll=" +
        encodeURIComponent(this.location.coords)
      );
    }
  }
};
</script>
